<script lang="ts">
  import type { Brand } from "../../interfaces/Brand"

  export let brandDetails: Brand | undefined
</script>

{#if brandDetails?.showAdaPrr}
  <img
    src="https://prod-service-media-stack-createprodservicemediabu-aqgzkrti4me.s3.us-west-1.amazonaws.com/2F198A6UdRh5U33Agssaovekxox/assets/images/logo.svg"
    alt={`${brandDetails?.name} logo`}
    class="store-logo"
  />
{:else}
  <div class="store-logo" />
{/if}
